import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

// Dari localization
const dariLocale = {
  name: 'dari',
  relativeTime: {
    future: 'در %s',
    past: '%s پیش',
    s: 'چند ثانیه',
    m: 'یک دقیقه',
    mm: '%d دقیقه',
    h: 'یک ساعت',
    hh: '%d ساعت',
    d: 'یک روز',
    dd: '%d روز',
    w: 'یک هفته',
    ww: '%d هفته',
    M: 'یک ماه',
    MM: '%d ماه',
    y: 'یک سال',
    yy: '%d سال'
  }
};

// Pashto localization
const pashtoLocale = {
  name: 'ps',
  relativeTime: {
    future: 'په %s کې',
    past: '%s دمخه',
    s: 'څو ثانیې',
    m: 'یو دقیقه',
    mm: '%d دقیقې',
    h: 'یو ساعت',
    hh: '%d ساعتونه',
    d: 'یو ورځ',
    dd: '%d ورځې',
    w: 'یو اونۍ',
    ww: '%d اونۍ',
    M: 'یو میاشت',
    MM: '%d میاشتې',
    y: 'یو کال',
    yy: '%d کلونه'
  }
};

// Register the locales
dayjs.locale(dariLocale);
dayjs.locale(pashtoLocale);

// Function to get localized relative time
export const getLocalizedRelativeTime = (date, language) => {
  try {
    const dayjsInstance = dayjs(date);
    if (!dayjsInstance.isValid()) return '';
    
    // Set the appropriate locale based on language
    if (language === 'dari') {
      return dayjsInstance.locale('dari').fromNow();
    } else if (language === 'ps') {
      return dayjsInstance.locale('ps').fromNow();
    } else {
      // Default to English
      return dayjsInstance.fromNow();
    }
  } catch (error) {
    console.error('Error getting localized relative time:', error);
    return '';
  }
};

// Function to format date with proper localization
export const formatLocalizedDate = (date, language, format = 'relative') => {
  try {
    const dayjsInstance = dayjs(date);
    if (!dayjsInstance.isValid()) return '';
    
    if (format === 'relative') {
      return getLocalizedRelativeTime(date, language);
    }
    
    // For absolute date formatting, you can add more formats here
    if (language === 'dari' || language === 'ps') {
      return dayjsInstance.format('YYYY/MM/DD');
    } else {
      return dayjsInstance.format('MM/DD/YYYY');
    }
  } catch (error) {
    console.error('Error formatting localized date:', error);
    return '';
  }
};

export default dayjs; 